import React, { Component } from 'react';
import './PaymentMethods.css';

class PaymentMethods extends Component {

  constructor(props) {
    super(props);
    this.state = {
      payments : ['visa.svg','master.svg','american.svg','paypal.svg']
    }
  }

  render() {
    const { payments } = this.state;
    return (
      <div className='payments-container'>
        <div className='row container-lg'>
          {
            payments.map((el,i) => (
              <div key={i} className={`payment-logo col-6 col-sm-${12/payments.length}`}>
                <img src={require(`../../assets/images/${el}`)} key={i} alt="Usaproductos" />
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

export default PaymentMethods;



// WEBPACK FOOTER //
// ./src/components/PaymentMethods/PaymentMethods.js